module.exports = __webpack_public_path__ + "static/media/aroma_red.c23b7f4f.svg";